import React from 'react'
import {findDOMNode} from "react-dom"

import Popover from "../../../../../core/gd-components/gd-popover/popover"

type Props = {
    projectCollectionId: ID
}

type State = {
    showPopover: boolean
}

// const debug = "PortfolioSettingsButton"
const debug = false

export default class PortfolioSettingsButton extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover: false
        }
    }

    showPopover = () => {
        this.setState({
            showPopover:true
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover:false
        })
    }

    onRename = () => {
        this.hidePopover()
        gd.modals.portfolio.rename(this.props.projectCollectionId)
    }

    onSettings = () => {
        this.hidePopover()
        gd.goTo('portfolio/{0}/info'.f(this.props.projectCollectionId))
        // gd.modals.portfolio.editSettings(this.props.projectCollectionId)
    }

    onDelete = () => {
        this.hidePopover()
        gd.modals.portfolio.deletePortfolio(this.props.projectCollectionId)
    }

    onDisabledClick = () => {
        this.hidePopover();
        gd.modals.other.notification("You have no access to perform this action.")
    }

    getActions = () => {
        const projectCollection     = gd.session.projectCollections.get(this.props.projectCollectionId)!
        const isFullAccessUser      = projectCollection.isFullAccessUser
        const isEditorAccessUser    = projectCollection.isEditorAccessUser

        return [{
            type        : 'action',
            icon        : "i5-pen",
            name        : "Rename",
            callback    : this.onRename,
            disabled    : !isEditorAccessUser
        }, {
            type        : 'action',
            icon        : "i5-settings",
            name        : "Settings",
            callback    : this.onSettings,
            disabled    : !isEditorAccessUser
        }, {
            type        : 'action',
            icon        : "i5-trash-alt",
            name        : "Delete",
            callback    : this.onDelete,
            disabled    : !isFullAccessUser
        }]
    }

    renderItem(key: number, data: any) {
        let res;
        switch (data.type) {
            case 'action':
                const proIcon = data.showPro ? <div className="ui5-ico-pro"/> : null;

                res = (
                    <div key={key} className={Classes('option with-icon', {'disabled': data.disabled})} onClick={!data.disabled ? data.callback : data.disabledCallback ? data.disabledCallback : this.onDisabledClick}>
                        <div className={Classes('ico', data.icon)}/>
                        <div className={Classes('label', {'premium-only':!!data.showPro})}>{data.name}</div>
                        {proIcon}
                    </div>
                )
                break

            case 'separator':
                res = <div key={key} className="separator"/>
                break
        }

        return res
    }

    renderPopover() {
        if (this.state.showPopover) {
            return (
                <Popover popoverClass       = {Classes("popover top-project-settings-button-popover w-200")}
                         attachment         = "top center"
                         targetAttachment   = "bottom center"
                         attachmentType     = "horizontal"
                         offset             = "0 0"
                         onClickOutside     = {()=>{this.hidePopover()}}
                         getTargetFunc      = {()=>findDOMNode(this)}>
                    <div className="ui5-popover-menu">
                        {this.getActions().map((a,key)=>this.renderItem(key,a))}
                    </div>
                    <div className="cf"/>
                </Popover>
            )
        }
    }

    render() {
        return (
            <div className="item-more" onClick={this.showPopover}>
                <div className="ui5-ico-more s20"/>
                {this.renderPopover()}
            </div>
        )
    }
}
